import {
    forwardRef,
    useImperativeHandle,
    useRef,
} from "react"
import DataElement from "../DataElement"

const AddressAndDateInput = forwardRef(({ title, attributes, data, readOnly }, ref) => {

    const dataElementRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const elementResult = dataElementRef.current.validateAndGetData()

            return elementResult
        },
    }))

    return (
        <div className="my-4">
            <label className="block text-base font-medium text-gray-700 mb-4">
                {title}
            </label>

            <DataElement
                ref={dataElementRef}
                attributes={attributes}
                data={data}
                readOnly={readOnly}
            />
        </div>
    )
})

export default AddressAndDateInput
